import type { CSSProperties, ReactNode } from 'react';

/**
 * Wraps the first N words in [[...]] bracket notation
 * so they receive the highlight/accent color treatment.
 */
export const applyAccentBrackets = (text: string, wordCount: number): string => {
  const words = text.split(' ');
  if (words.length <= wordCount) return `[[${text}]]`;
  const accent = words.slice(0, wordCount).join(' ');
  const rest = words.slice(wordCount).join(' ');
  return `[[${accent}]] ${rest}`;
};

/** Parses `<b>...</b>` tags into `<strong>` elements. */
export const parseBoldTags = (text: string): ReactNode => {
  const parts = text.split(/<b>|<\/b>/i);
  if (parts.length === 1) return text;

  return parts.map((part, i) => {
    if (!part) return null;
    if (i % 2 === 1) {
      return (
        <strong key={i} style={{ fontWeight: 'var(--font-bold, 700)' } as CSSProperties}>
          {part}
        </strong>
      );
    }
    return part;
  });
};
